import { render, staticRenderFns } from "./ReviewChangesDialog.vue?vue&type=template&id=6371c51b&scoped=true"
import script from "./ReviewChangesDialog.vue?vue&type=script&lang=js"
export * from "./ReviewChangesDialog.vue?vue&type=script&lang=js"
import style0 from "./ReviewChangesDialog.vue?vue&type=style&index=0&id=6371c51b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6371c51b",
  null
  
)

export default component.exports